import consumer from "./consumer"
import { turboRequest } from "../helpers/api"
consumer.subscriptions.create("LoginSessionChannel", {
  connected() {
    console.log("Login session channel connected")
  },

  async received(data) {
    if (data.action !== "logout") return

    await turboRequest("/users/sign_out", {
      method: "DELETE",
      turboStream: true,
      html: true,
      onSuccess: (result, response) => { }
    })
  }
})
